import { BannerCloseButton } from '@/components/common/banner/BannerCloseButton';
import { InfoIcon } from '@/app/icons/InfoIcon';
import { MaterialDesignContent, SnackbarKey, SnackbarProvider, SnackbarProviderProps } from 'notistack';
import { OutlineSuccessIcon } from '@/app/icons/OutlineSuccessIcon';
import { OutlineWarnIcon } from '@/app/icons/OutlineWarnIcon';
import { Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { FC } from 'react';

type Props = SnackbarProviderProps;

const StyledBannerContent = styled(MaterialDesignContent)(({ theme }) => ({
  '&.notistack-MuiContent': {
    borderRadius: '12px',
    padding: theme.spacing(1, 2),
  },
  '&.notistack-MuiContent-success': {
    backgroundColor: theme.colors.greenBackground,
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: theme.colors.red,
  },
  '&.notistack-MuiContent-info': {
    color: theme.colors.textColor,
    backgroundColor: 'white',
  },
  '&.notistack-MuiContent-warning': {
    color: theme.colors.textColor,
    backgroundColor: theme.colors.tooltip,
  },
}));

export const BannerProvider: FC<Props> = (props: Props) => {
  const { children } = props;
  return (
    <SnackbarProvider
      style={{ flexWrap: 'nowrap' }}
      maxSnack={3}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      Components={{
        success: StyledBannerContent,
        error: StyledBannerContent,
        info: StyledBannerContent,
        warning: StyledBannerContent,
      }}
      iconVariant={{
        success: (
          <OutlineSuccessIcon
            sx={{
              width: (theme: Theme) => theme.spacing(3),
              height: (theme: Theme) => theme.spacing(3),
              color: 'white',
              display: 'block',
              marginRight: (theme: Theme) => theme.spacing(1),
            }}
          />
        ),
        error: (
          <InfoIcon
            sx={{
              width: (theme: Theme) => theme.spacing(3),
              height: (theme: Theme) => theme.spacing(3),
              color: 'white',
              display: 'block',
              marginRight: (theme: Theme) => theme.spacing(1),
            }}
          />
        ),
        info: (
          <InfoIcon
            sx={{
              width: (theme: Theme) => theme.spacing(3),
              height: (theme: Theme) => theme.spacing(3),
              color: (theme: Theme) => theme.colors.textColor,
              display: 'block',
              marginRight: (theme: Theme) => theme.spacing(1),
            }}
          />
        ),
        warning: (
          <OutlineWarnIcon
            sx={{
              width: (theme: Theme) => theme.spacing(3),
              height: (theme: Theme) => theme.spacing(3),
              color: (theme: Theme) => theme.colors.textColor,
              display: 'block',
              marginRight: (theme: Theme) => theme.spacing(1),
            }}
          />
        ),
      }}
      action={(key: SnackbarKey) => <BannerCloseButton snackbarKey={key} />}
      {...props}>
      {children}
    </SnackbarProvider>
  );
};
